import template from './vue-pill-bar.vue.html';

export const VuePillBarComponent = {
	template,
	model  : {
		prop : 'selection',
		event: 'input'
	},
	props  : {
		pills    : Array, // enters via :pills in the template
		selection: {
			default: [],
			type   : Array
		}
	},
	data() {
		return {
			currentSelection: this.selection
		};
	},
	methods: {
		/**
		 * Triggers jQuery event
		 * @param evt {Event}
		 */
		triggerChange: function ( evt ) {
			this.$emit( 'input', this.currentSelection );
			$( this.$el ).trigger( 'change', { val: this.currentSelection } );
			evt.stopPropagation();
		},
	},
};


export const VuePillBarPlugin = {
	install( Vue, options ) {
		Vue.component( 'defa-pill-bar', VuePillBarComponent );
	}
};